import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

type TInitialValuesLayout = {
  isCollapsed: boolean;
};

const initialState: TInitialValuesLayout = {
  isCollapsed: false,
};

export const layoutSlice = createSlice({
  name: 'ui/layout',
  initialState,
  reducers: {
    setIsCollapsed(state, { payload }: PayloadAction<boolean>) {
      return { ...state, isCollapsed: payload };
    },
  },
});

const selectLayout = (state: RootState) => state.ui.layout;

export const selectors = { selectLayout };
export const actions = layoutSlice.actions;
export const reducer = layoutSlice.reducer;
